import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  highlightedImageContainer: {
    position: "relative",
    display: "inline-block",
  },
  highlightedImage: {
    maxHeight: "50vh",
    width: "100%",
    objectFit: "contain",
    cursor: "pointer",
  },
  controls: {
    display: "flex",
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  },
  carousel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
  lockedImageWrapper: {
    position: "relative",
    width: 125,
    height: 125,
    borderRadius: 8,
    cursor: "pointer",
    overflow: "hidden",
    [theme.breakpoints.down("xl")]: {
      width: 75,
      height: 75,
    },
  },
  lockIconWrapper: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderRadius: "50%",
    padding: theme.spacing(0.5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  lockIcon: {
    width: 24,
    height: 24,
    color: "#ececec",
    [theme.breakpoints.down("xl")]: {
      width: 15,
      height: 15,
    },
  },
  blurredImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));
